let React      = require("react");

let Footer     = require("../controls/Footer.jsx");
let SiteHeader = require("../controls/SiteHeader.jsx");
var ApplicationContext = require("../config/ApplicationContext.js");
let Application        = require("../Application.js");


const SECTION_NAME = "InvitedAccountMismatch";

class InvitedAccountMismatch extends React.Component {

    constructor(){
        super();

        this.onSearch = this.onSearch.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount(){
        googleGA("send", "event", "page invitation no pending", "pageview");
        document.title = `Page invitation no pending | library.io`;
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    logout(){
      googleGA("send", "event", "errorPage", "signout");
      Application.dataStore.logoutUser();
    }

    render() {
        return  <div className="pageNotFound">
                    <SiteHeader type="Explore" onSearch={this.onSearch}/>

                     {!ApplicationContext.getUserData() && <h1 className="pageNotFound__title">Successfully Signed Out.</h1>}
                     {
                       ApplicationContext.getUserData() && <div>
                         <h1 className="pageNotFound__title">Wrong Account</h1>
                         <p className="pageNotFound__description">
                         Your email <b>{ApplicationContext.getUserData().email}</b> is not the email this invitation was sent to. <br/><br/>
                         If you are logged into the wrong account, you can <b><u className="signOut" onClick={this.logout}>log out</u>, then try the invite link again.</b>  <br/><br/>
                         If the intention was to invite this account, <br/> the invitation will need to be sent to {ApplicationContext.getUserData().email} instead. </p>
                       </div>
                     }

                    <Footer type={SECTION_NAME}/>
                </div>
    }
}

module.exports = InvitedAccountMismatch;
